import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsCA from "./ca.json";
import translationsEN from "./en.json";
import translationsES from "./es.json";
// The translations
const resources = {
  en: {
    translation: translationsEN
  },
  es: {
    translation: translationsES
  },
  ca: {
    translation: translationsCA
  }
};

const SUPPORTED_LANGUAGES = ["ca", "es", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const isSupportedLanguage = (lng: string): lng is SupportedLanguage =>
  SUPPORTED_LANGUAGES.includes(lng as SupportedLanguage);

export const changeLanguage = (lng: string) => {
  const language = getLngCode(lng);
  i18n.changeLanguage(language);
  localStorage.setItem("selectedLanguage", language);
};

// Returns standardized 2-letter code for backend
export const getLngCode = (lng: string): string => {
  const code = (lng || "ca").slice(0, 2).toLowerCase();
  return isSupportedLanguage(code) ? code : "ca";
};

export const getLanguageFromUrl = (): SupportedLanguage | null => {
  const langParam = new URLSearchParams(window.location.search).get("lang");
  if (!langParam) return null;

  const code = langParam.slice(0, 2).toLowerCase();
  return isSupportedLanguage(code) ? code : null;
};

const resolveInitialLanguage = (): SupportedLanguage => {
  const urlLanguage = getLanguageFromUrl();
  if (urlLanguage) {
    localStorage.setItem("selectedLanguage", urlLanguage);
    return urlLanguage;
  }

  const savedLanguage = localStorage.getItem("selectedLanguage");
  return savedLanguage && isSupportedLanguage(savedLanguage)
    ? savedLanguage
    : "ca";
};

const initialLng = resolveInitialLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: "ca",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
